import React from 'react';
import clsx from 'clsx';

import BracketMatch from './components/bracket-match';
import {ROUNDS} from './constants';

import styles from './playoff-bracket.module.css';

const PlayoffBracket = ({matches}) => {
  const {round3, round4, round5, semifinal, final} = matches;
  const upperBracketRoundThreeClassnames = clsx('bracketSubPart', 'bracketSubPartDowngrade');
  const lowerBracketRoundThreeClassnames = clsx('bracketSubPart', 'bracketSubPartDoubleDisposal');
  const bracketDisposalClassnames = clsx('bracketSubPart', 'bracketSubPartDisposal');
  const emptyLargeBracketClassnames = clsx('bracketSubPart', 'bracketSubPartDoubleDisposal', 'bracketSubPartEmptyLarge');
  const emptyBracketClassnames = clsx('bracketSubPart', 'bracketSubPartEmpty');
  const emptySmallBracketClassnames = clsx('bracketSubPart', 'bracketSubPartEmptySmall');
  const semifinalsBracketClassnames = clsx('bracketSubPart', 'bracketSubPartSemiFinals');
  const finalsBracketClassnames = clsx('bracketSubPart', 'bracketSubPartLarge');
  const renderBracketMatch = (className = '') =>
    (teams, index) => <BracketMatch teams={teams} key={teams[0]?.id || index} className={className} />;

  return (
    <div className={styles.widgetWrapper}>
      <div className={styles.roundsWrapper}>
        {ROUNDS.map(round => (
          <p className={styles.roundName} key={round}>
            {round}
          </p>
        ))}
      </div>
      <div className={styles.bracketWrapper}>
        <div className={styles.bracketPart}>
          <div className={emptyLargeBracketClassnames} />
          <div className={lowerBracketRoundThreeClassnames}>
            {round3.map(teams => teams.map(renderBracketMatch(styles.bracketMatch)))}
          </div>
        </div>
        <div className={styles.bracketPart}>
          <div className={upperBracketRoundThreeClassnames}>
            {round4[0].map(renderBracketMatch(styles.bracketMatch))}
          </div>
          <div className={upperBracketRoundThreeClassnames}>
            {round4[1].map(renderBracketMatch(styles.bracketMatch))}
          </div>
        </div>
        <div className={styles.bracketPart}>
          <div className={emptyBracketClassnames} />
          <div className={bracketDisposalClassnames}>
            {round5[0].map(renderBracketMatch())}
          </div>
        </div>
        <div className={styles.bracketPart}>
          <div className={emptySmallBracketClassnames}>
            {semifinal[0].map(renderBracketMatch())}
          </div>
          <div className={semifinalsBracketClassnames}>
            {semifinal[1].map(renderBracketMatch())}
          </div>
        </div>
        <div className={styles.bracketPart}>
          <div className={finalsBracketClassnames}>
            {final[0].map(renderBracketMatch())}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlayoffBracket;
